var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"input-value":_vm.readonly,"label":_vm.$t('config.readonly'),"disabled":_vm.disabled,"inset":"","dense":""},on:{"change":_vm.toggleReadonly}})}
var staticRenderFns = []

export { render, staticRenderFns }